import { Injectable, ViewChildren, QueryList } from '@angular/core';
import { IonRouterOutlet, ActionSheetController, ModalController, AlertController, PopoverController } from "@ionic/angular";

/**
 * Service to close automatically all overlay elements (modal, alert...)
 */
@Injectable({
    providedIn: 'root'
})
export class AutocloseOverlaysService {
    @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;

    constructor(
        private _actionSheetCtrl: ActionSheetController,
        private _modalCtrl: ModalController,
        private _alertCtrl: AlertController,
        private _popoverCtrl: PopoverController
    ) { }

    /**
     * Close any overlay like modals or alerts
     * @returns Promise that closes active overlay
     */
    async closeActiveOverlays(): Promise<void> {

        // Close active alert
        try {
            const alert: HTMLIonAlertElement = await this._alertCtrl.getTop();
            alert?.dismiss();
        } catch (error) { }

        // Close active modal
        try {
            const modal: HTMLIonModalElement = await this._modalCtrl.getTop();
            modal?.dismiss();
        } catch (error) { }

        // Close active action sheet
        try {
            const actionSheet: HTMLIonActionSheetElement = await this._actionSheetCtrl.getTop();
            actionSheet?.dismiss();
        } catch (error) { }

        // Close active popover
        try {
            const popover: HTMLIonPopoverElement = await this._popoverCtrl.getTop();
            popover?.dismiss();
        } catch (error) { }

    }
}